export function create_overrides() {
    const overrides = {
        only: new Set(),
        exclude: new Set(),
        clear: () => {
            overrides.only.clear();
            overrides.exclude.clear();
        }
    };
    return overrides;
}
//# sourceMappingURL=types.js.map